/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Vertical_Text_TitleInputs */

const en_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical Text`)
};

const fr_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte Vertical`)
};

const de_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertikaler Text`)
};

const it_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo verticale`)
};

const ru_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вертикальный текст`)
};

const es_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto vertical`)
};

const zh_cn2_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`竖文本`)
};

const ja_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`縦書きテキスト`)
};

const hi_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊर्ध्वाधर पाठ`)
};

const pt_pt2_input_position_vertical_text_title = /** @type {(inputs: Input_Position_Vertical_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto vertical`)
};

/**
* | output |
* | --- |
* | "Vertical Text" |
*
* @param {Input_Position_Vertical_Text_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_vertical_text_title = /** @type {((inputs?: Input_Position_Vertical_Text_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Vertical_Text_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_vertical_text_title(inputs)
	if (locale === "de") return de_input_position_vertical_text_title(inputs)
	if (locale === "it") return it_input_position_vertical_text_title(inputs)
	if (locale === "ru") return ru_input_position_vertical_text_title(inputs)
	if (locale === "es") return es_input_position_vertical_text_title(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_vertical_text_title(inputs)
	if (locale === "ja") return ja_input_position_vertical_text_title(inputs)
	if (locale === "hi") return hi_input_position_vertical_text_title(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_vertical_text_title(inputs)
	return en_input_position_vertical_text_title(inputs)
});